import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Input } from "formsy-react-components";
import Formsy from "formsy-react";
import { Row, Col } from "react-bootstrap";

class ConfirmUpdateCallModal extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      ...this.props.call
    };
  }

  // if call type is_billable, check contract to determine billable_hrs
  calculateBillableHours = (contractId, actual_hrs) => {
    const contract = this.props.contracts?.find((c) => c._id === contractId);
    const contractType = contract?.contract_type?.value;
    let billable_hrs = 0;
    switch (contractType) {
      case "FIXED FEE":
      case "RETAINER":
      case "CLIENTCARE":
      case "CAPITAL":
      case "MANAGED SERVICES":
        billable_hrs = actual_hrs;
        break;
      default:
        billable_hrs = Math.ceil(actual_hrs);
        break;
    }
    return billable_hrs;
  };

  cancel = () => {
    this.props.onCancel();
  };

  render() {
    const { call } = this.props;
    const callTypes = this.props.codes.filter(
      (c) => c.entity === "Call" && c.field === "type"
    );

    const type = callTypes.find((c) => c._id === call.call_type);

    const new_billable_hours =
      type && type.is_billable
        ? this.calculateBillableHours(call.contract, call.actual_hrs) || 0
        : 0;

    return (
      <div>
        <Formsy ref={(ref) => (this.form = ref)} className="vertical form">
          <Row>
            <Col md={4}>
              <Input
                name="actual_hrs"
                label="Actual Hours"
                readOnly
                disabled
                value={this.state.actual_hrs}
              />
            </Col>
            <Col md={4}>
              <Input
                name="billable_hours"
                label="Current Billable Hours"
                readOnly
                disabled
                value={this.state.billable_hrs}
              />
            </Col>
            <Col md={4}>
              <Input
                name="new_billable_hours"
                label="Updated Billable Hours"
                readOnly
                disabled
                value={new_billable_hours}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12} className="footer">
              <button
                className="btn  btn-cancel"
                type="button"
                onClick={this.cancel}
              >
                Cancel
              </button>
              <input
                className="btn  btn-blue"
                onClick={() => this.props.onSubmit(this.state, false)}
                value="Save Current Hours"
              />
              <input
                className="btn  btn-success"
                onClick={() => this.props.onSubmit(this.state, true)}
                value="Save Updated Hours"
              />
            </Col>
          </Row>
        </Formsy>
      </div>
    );
  }
}

ConfirmUpdateCallModal.propTypes = {
  call: PropTypes.object,
  codes: PropTypes.array,
  contracts: PropTypes.array,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func
};

function mapStatesToProps(state) {
  return {
    state: state.reducers
  };
}

export default connect(mapStatesToProps)(ConfirmUpdateCallModal);
